import { render, staticRenderFns } from "./AppManifest.vue?vue&type=template&id=5ec13e22&scoped=true&"
var script = {}
import style0 from "./AppManifest.vue?vue&type=style&index=0&id=5ec13e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec13e22",
  null
  
)

export default component.exports